module.exports = __webpack_public_path__ + "media/images/wave-bg-6ca057c4966c847f733629ab66e06a20.png";